import moment, { Moment } from 'moment'
import React, { ChangeEvent, FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import {
  IAppointment,
  IAppointmentFormSubmission,
  IBlock,
  IBlockFormSubmit,
} from '../../types'
import { handleAppointmentUpdate } from '../handleAppointmentUpdate'

interface IProps {
  setValue: UseFormSetValue<any>
  appointmentMoment?: Moment
  inputName: keyof IAppointmentFormSubmission | keyof IBlockFormSubmit
  labelName?: string
  updateAppointment?: IAppointment
  updateBlock?: IBlock
}

export const HourPicker: FunctionComponent<IProps> = ({
  appointmentMoment,
  inputName,
  labelName,
  setValue,
  updateAppointment,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const dropDownChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setValue(inputName, e.target.value)
    if (
      typeof updateAppointment !== 'undefined' &&
      typeof appointmentMoment !== 'undefined'
    ) {
      const splitTime = e.target.value
        .split(':')
        .map(time => parseInt(time, 10))
      const updatedTime = appointmentMoment.clone().set({
        hour: splitTime[0],
        minute: splitTime[1],
      })
      handleAppointmentUpdate(updateAppointment, updatedTime, 'hour', dispatch)
    }
  }

  const hourArray: number[][] = []
  for (let i = 0; i < 24; i += 1) {
    for (let j = 0; j < 4; j += 1) {
      hourArray.push([i, 15 * j])
    }
  }

  const appointmentHoursArray = hourArray.map(timestamp => {
    const timeSelection = moment({
      hour: timestamp[0],
      minute: timestamp[1],
    }).format('HH:mm')

    const isSelectedHour: boolean =
      typeof appointmentMoment !== 'undefined' &&
      appointmentMoment.hour() === timestamp[0] &&
      appointmentMoment.minute() === timestamp[1]

    return (
      <option
        selected={isSelectedHour}
        key={timeSelection}
        value={timeSelection}>
        {timeSelection}
      </option>
    )
  })

  return (
    <p>{'Code is commented atm.'}</p>
    // <LabelSelect
    //   fieldLabel={labelName || t('Time')}
    //   fieldColor="#005cd9"
    //   leadingIcon="clock"
    //   onChange={e => dropDownChange(e)}
    //   optionsArray={appointmentHoursArray}
    //   customWidth="400px"
    // />
  )
}
